import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const  ButtonFileUpload = ({ onChange, label, multiple, className, ...btnProps}) => {
  return (
    <Button
    //    turn the button into a label using component="label" and then create a visually-hidden input with type file.
        component="label" 
        role={undefined}
        variant="contained"
        tabIndex={-1}
        className={className}
    >
      {label}
      <VisuallyHiddenInput
        type="file"
        onChange={onChange}
      />
    </Button>
  );
}

export default ButtonFileUpload